import type { IconProps } from '../../../components/Icon/Icon.util';

export const TinyCheckmark = ({
  title,
  width = 32,
  height = 32,
  fill = 'none',
  role = 'presentation',
}: IconProps): React.ReactNode => {
  const viewBoxSize = 16;

  return (
    <svg
      fill={fill}
      focusable='false'
      height={height}
      role={role}
      viewBox={`0 0 ${viewBoxSize} ${viewBoxSize}`}
      width={width}
      xmlns='http://www.w3.org/2000/svg'
    >
      {title ? <title>{title}</title> : null}

      <path d='M7.1194 12.5931C7.0867 12.6358 7.05085 12.6767 7.01185 12.7158L6.55086 13.177C6.07029 13.6578 5.2883 13.6597 4.80707 13.1782L0.860678 9.22975C0.37889 8.7477 0.380245 7.96696 0.861922 7.48502L1.32291 7.02379C1.80348 6.54296 2.58548 6.54106 3.06671 7.02254L5.67084 9.62807L12.9317 2.36334C13.415 1.87976 14.1961 1.87866 14.6786 2.36142L15.1396 2.82265C15.6209 3.30419 15.62 4.08802 15.1377 4.57055L7.1194 12.5931Z' />
    </svg>
  );
};
